import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import { localizeUrl } from '@homeaway/localization-utils';
import actions from '../actions/actions';
import accountCreationActions from '../actions/accountCreation';
import helpActions from '../actions/help';
import { saveUserDetails } from '../utils/localStorageDataHandler';

function sendHelpEmail(store) {
    const state = store.getState();
    let { companyLocation, propertyCount, account } = state;
    const helpFormData = {
        data: {
            firstName: account.firstName,
            lastName: account.lastName,
            emailAddress: account.email,
            companyName: account.companyName,
            companyLocation: companyLocation.companyCountryInfo.countryName,
            vatStatus: companyLocation.vatChoice,
            propertyCount: propertyCount.numberOfProperty,
            businessUnit: companyLocation.businessType,
            phoneNumber: `+${account.countryDialingNumber}-${account.phoneNumber}`,
            message: 'USER_CONFLICT'
        },
        type: 'INELIGIBLE'
    };
    store.dispatch(helpActions.submitHelpForm(helpFormData));
}

const getPreferredLocale = (store) => {
    const { system } = store.getState();
    return system.preferredLocale;
}

// responds to 'SAVE_ACCOUNT' action
function createAccount(store, action) {
    const accountDetails = action.payload.accountDetails;
    const preferredLocale = getPreferredLocale(store);

    request.post(`/${config.url_prefix}/api/createAccount?locale=${preferredLocale}`)
        .send({
            data: accountDetails
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .set('Access-Control-Allow-Credentials', 'true')
        .set('Access-Control-Allow-Headers', 'Set-Cookie')
        .end((error, response) => {
            if (error) {
                const errorKey = 'ipmob.internal.server.error';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(accountCreationActions.alertError(errorKey));
            } else if (response.text.includes('code')) {
                let errorActionToDispatch;
                const parsedResponse = JSON.parse(response.text);
                if (parsedResponse.code === 700) {
                    errorActionToDispatch = accountCreationActions.setAccountExistsError('ipmob.create_account.error.account.exists');
                    sendHelpEmail(store);
                } else if (parsedResponse.code === 705) {
                    saveUserDetails(accountDetails);

                    // if Traveler user is logged in, skip dispatching error
                    if (store.getState().app?.authState && store.getState().app?.userType === 'TRAVELER') {
                        // move to logged-in Traveler workflow to continue SSO
                        window.location = localizeUrl('/t/onboard/traveler', window.__SITE_CONTEXT__);
                    } else {
                        // otherwise show existing error experience
                        errorActionToDispatch = accountCreationActions.alertError('ipmob.create_account.error.traveler');
                    }

                } else {
                    errorActionToDispatch = accountCreationActions.alertError('ipmob.internal.server.error');
                }
                store.dispatch(errorActionToDispatch);
                store.dispatch(actions.enableLoadOverLay(false));
            } else {
                window.location = '/p/onboard'
            }
        });
}

export default createAccount;
